"use client"
import { StarRating } from "@/components/atoms"
import { useTranslate } from "@tolgee/react"

export const SellerScore = ({
  rate,
  reviewCount,
}: {
  rate: number
  reviewCount: number
}) => {
  const { t } = useTranslate()
  return (
    <div className="flex items-center flex-col label-md h-full py-12">
      <h3 className="heading-sm uppercase mb-2">{t("seller_score.seller_score")}</h3>
      <div className="flex gap-2 items-center mb-4 text-secondary">
        <StarRating rate={rate} starSize={16} /> {rate.toFixed(1)}
      </div>
      <p className="text-secondary">{reviewCount} {t("seller_score.reviews")}</p>
    </div>
  )
}
